import React, { useState, useContext } from "react";
import {
  Avatar,
  Box,
  ButtonBase,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faMoon,
  faSignOutAlt,
  faSun,
  faUserCog,
} from "@fortawesome/free-solid-svg-icons";
import { DataContext } from "../context/DataContext";
import { getRuta, simpleMessage } from "../helpers/Helpers";
import {
  apiLogOut,
  changeThemeAsync,
  getRol,
  getToken,
  getUser,
} from "../api/Account";

// Con un nombre de una sola palabra (o vacío) no hay segunda inicial: no debe reventar.
const partesDelNombre = (nombre) =>
  nombre ? nombre.trim().split(/\s+/).filter(Boolean) : [];

const NavBarElements = () => {
  let navigate = useNavigate();
  const user = getUser();
  const rol = getRol() || "";
  const token = getToken();
  const rout = getRuta();

  const { isDarkMode, setIsDarkMode, setIsLogged, setIsLoading } =
    useContext(DataContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logOut = () => {
    const result = apiLogOut();
    if (!result.statusResponse) {
      simpleMessage("No se pudo cerrar sesión, intente de nuevo", "error");
    }
    setIsDarkMode(false);
    setIsLogged(false);
    navigate(rout);
  };

  const myAccount = () => {
    handleClose();
    navigate(`${rout}/account`);
  };

  const changeTheme = async () => {
    handleClose();
    setIsLoading(true);
    const resul = await changeThemeAsync(token);
    if (!resul.statusResponse) {
      setIsLoading(false);
      simpleMessage("No se pudo cambiar el tema", "error");
      return;
    }

    setIsDarkMode(!isDarkMode);
    setIsLoading(false);
  };

  const partes = partesDelNombre(user);
  const iniciales = partes
    .slice(0, 2)
    .map((parte) => parte[0])
    .join("")
    .toUpperCase();
  const nombreCorto =
    partes.length > 1 ? `${partes[0]} ${partes[1][0]}.` : partes[0] || "";

  return (
    <Box sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
      <ButtonBase
        aria-label={`${nombreCorto || "Mi cuenta"}${rol ? `, ${rol}` : ""}, menú de cuenta`}
        aria-controls="menu-appbar"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleMenu}
        sx={{
          gap: 1.5,
          minWidth: 0,
          maxWidth: 260,
          p: 0.5,
          pr: 1.5,
          borderRadius: 6,
          textAlign: "left",
        }}
      >
        <Avatar
          sx={{
            bgcolor: "primary.main",
            color: "primary.contrastText",
            width: 40,
            height: 40,
            fontSize: 16,
            fontWeight: 700,
          }}
        >
          {iniciales}
        </Avatar>

        {/* En el teléfono solo cabe el avatar. */}
        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "column",
            minWidth: 0,
          }}
        >
          <Typography noWrap sx={{ fontWeight: 700, color: "text.primary" }}>
            {nombreCorto}
          </Typography>
          <Typography
            noWrap
            title={rol}
            variant="caption"
            sx={{ color: "text.secondary" }}
          >
            {rol}
          </Typography>
        </Box>

        <Box
          component="span"
          aria-hidden="true"
          sx={{ display: "flex", color: "text.secondary" }}
        >
          <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: 12 }} />
        </Box>
      </ButtonBase>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={myAccount}>
          <ListItemIcon sx={{ color: "inherit" }}>
            <FontAwesomeIcon icon={faUserCog} fixedWidth />
          </ListItemIcon>
          <ListItemText>Mi cuenta</ListItemText>
        </MenuItem>
        <MenuItem onClick={changeTheme}>
          <ListItemIcon sx={{ color: "inherit" }}>
            <FontAwesomeIcon icon={isDarkMode ? faMoon : faSun} fixedWidth />
          </ListItemIcon>
          <ListItemText>{isDarkMode ? "Tema claro" : "Tema oscuro"}</ListItemText>
        </MenuItem>
        <MenuItem onClick={logOut}>
          <ListItemIcon sx={{ color: "inherit" }}>
            <FontAwesomeIcon icon={faSignOutAlt} fixedWidth />
          </ListItemIcon>
          <ListItemText>Cerrar sesión</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default NavBarElements;
